/**
 * @author      carlos.soto@zumper.com (Carlos J. Soto)
 * @copyright   Copyright (c) 2023, Zumper
 * @description getAbsoluteUrl
 */

import { isAbsoluteUrl } from '@zcode/utils'

import { APP_HOSTNAME } from '../../../settings'

export const getAbsoluteUrl = (url: string) => {
  if (isAbsoluteUrl(url)) {
    return url
  }
  if (url.charAt(1) === '/') {
    // `//foo.com/path` case, use window.protocol or https
    return `${typeof window !== 'undefined' ? window?.location?.protocol : 'https:'}//${url.slice(
      2
    )}`
  } else {
    // `/path/bar` case, use window.protocol//window.host or https://settings

    return `${typeof window !== 'undefined' ? window?.location?.protocol : 'https:'}//${
      typeof window !== 'undefined' ? window?.location?.host : (APP_HOSTNAME as string)
    }${url}`
  }
}
